import * as DOMPurify from "dompurify"
import {forwardRef, useMemo} from "react"

export function useSanitize(dirty) {
  const clean = useMemo(() => DOMPurify.sanitize(dirty), [dirty])

  return clean
}

const SanitizedHtml = forwardRef(function SanitizedHtml({dirty, tagName, ...restProps}, ref) {
  const cleanHtml = useSanitize(dirty)
  const CustomTag = tagName || "div"

  return <CustomTag {...restProps} dangerouslySetInnerHTML={{__html: cleanHtml}} ref={ref} />
})

export default SanitizedHtml
